/**
 * Hermes bridge config — API key and base URL for local gateway.
 */
const STORAGE_KEY = 'qawaem_hermes_bridge';

const DEFAULTS = {
  apiBase: 'http://127.0.0.1:8642',
  apiKey: '',
};

export function getHermesBridgeConfig() {
  if (typeof window !== 'undefined' && window.electronAPI?.hermes?.getConfig) {
    return window.electronAPI.hermes.getConfig();
  }

  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      return { ...DEFAULTS, ...parsed };
    }
  } catch {
    /* ignore */
  }

  return {
    ...DEFAULTS,
    apiKey: process.env.REACT_APP_HERMES_API_KEY || '',
    apiBase: process.env.REACT_APP_HERMES_API_BASE || DEFAULTS.apiBase,
    cloudAiUrl:
      process.env.REACT_APP_CF_AI_URL ||
      'https://qawaem-platform.qawaemaicode.workers.dev/ai/openai/v1',
    llmKey: process.env.REACT_APP_HERMES_LLM_KEY || '',
  };
}

export function saveHermesBridgeConfig(partial) {
  const next = { ...getHermesBridgeConfig(), ...partial };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    /* ignore */
  }
  return next;
}

export function getAgentEngineMode() {
  return (
    process.env.REACT_APP_AGENT_ENGINE ||
    localStorage.getItem('qawaem_agent_engine') ||
    'hybrid'
  );
}
